import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Line } from "react-chartjs-2";
import ChartColorService from "../../../Services/Shared/ChartColor.service";
import CustomCard from "../../UI/CustomCard/CustomCard";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import NumberService from "../../../Services/Shared/Number.service";
import DateService from "../../../Services/Shared/Date.service";
const options = {
    scales: {
        xAxes: [
            {
                gridLines: {
                    display: false,
                    drawBorder: false,
                },
                bounds: "ticks",
                type: "time",
                time: {
                    unit: "day",
                },
            },
        ],
    },
    tooltips: {
        callbacks: {
            // @ts-expect-error - TS7006 - Parameter 'tooltips' implicitly has an 'any' type.
            title: (tooltips) => {
                return DateService.display(new Date(tooltips[0].label));
            },
            // @ts-expect-error - TS7006 - Parameter 'tooltip' implicitly has an 'any' type.
            label: (tooltip) => {
                return NumberService.format(tooltip.yLabel);
            },
        },
    },
    legend: {
        position: "bottom",
    },
};
const EmailDataChart = (props) => {
    var _a;
    const data = {
        datasets: [
            Object.assign(Object.assign({ label: "Open Count", data: props.countsOverTime.map((el) => ({
                    t: el.periodStart,
                    y: el.openCount,
                })), fill: false }, ChartColorService.Blue), { lineTension: 0, borderWidth: 2 }),
            Object.assign(Object.assign({ label: "Click Count", data: props.countsOverTime.map((el) => ({
                    t: el.periodStart,
                    y: el.clickCount,
                })), fill: false }, ChartColorService.Red), { lineTension: 0, borderWidth: 2 }),
        ],
    };
    return (_jsx(CustomCard, { title: "Email Data Chart", className: "mb-3", children: _jsx("div", { className: "card-body", children: ((_a = props.countsOverTime) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (_jsx("div", { className: "p-5", children: _jsx(Line, { data: data, options: options }) })) : (_jsx(AlertInfo, { message: "No data" })) }) }));
};
export default EmailDataChart;
